import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DoorsSelectors } from '@states/doors/doors.selector-types';
import { PreloaderColor } from '@enums/shared.enum';
import { features } from '@consts/text.const';
import { DoorModels } from '@models/door.model';
import { Component, Inject, OnInit } from '@angular/core';
import { EnableEscCloseDirective } from '../../directives/enable-esc-close.directive';
import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { AuthSrcDirective } from '../../directives/auth-src.directive';
import { MatInput } from '@angular/material/input';
import { UiKitModule } from '../ui-kit.module';
import { MatIcon } from '@angular/material/icon';
import { MatFormField } from '@angular/material/select';
import { UiPreloaderComponent } from '../ui-preloader/ui-preloader.component';
import { UiButtonComponent } from '@ui';
import { ThumbnailsService } from '../../../development/thumbnails.service';

export enum DoorAddState {
  OPEN_STATE,
  CLOSE_STATE,
  NAME,
  NO_DATA
}

export interface UiDoorDialogData {
  door?: DoorModels.Door;
  toExisting?: boolean;
  selector?: boolean;
  list?: DoorModels.Door[];
}

@Component({
  selector: 'app-ui-door-dialog',
  templateUrl: './ui-door-dialog.component.html',
  styleUrls: ['./ui-door-dialog.component.scss'],
  hostDirectives: [EnableEscCloseDirective],
  imports: [
    ReactiveFormsModule,
    MatDialogClose,
    NgSwitch,
    MatIcon,
    NgSwitchCase,
    AuthSrcDirective,
    MatFormField,
    MatInput,
    NgSwitchDefault,
    UiKitModule,
    NgIf,
    UiButtonComponent,
    UiPreloaderComponent,
  ],
})
export class UiDoorDialogComponent implements OnInit {
  public noSaved = features.doors.noSaved;

  public PreloaderColor = PreloaderColor;
  public selectSavedDoors$: Observable<DoorModels.Door[]> = this.store$.pipe(
    select(DoorsSelectors.selectSavedDoors),
  );

  public selectedDoorId = '';
  public selectedDoorIds = [];
  loaded = false;
  closed;
  opened;

  public query = '';

  public loading = false;

  form = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required]),
  });

  public DoorAddState = DoorAddState;
  public addState: DoorAddState = DoorAddState.CLOSE_STATE;

  constructor(
    private store$: Store,
    @Inject(MAT_DIALOG_DATA) public data: UiDoorDialogData,
    private dialogRef: MatDialogRef<UiDoorDialogComponent>,
    private thumbnailsService: ThumbnailsService,
  ) {}

  ngOnInit(): void {
    if (this.data?.door) {
      const door = this.data?.door;
      const trainingBase = this.thumbnailsService.getTrainingThumbnailsBaseUrl(door.edgeId, false);
      this.closed = `${trainingBase}/training/${door.edgeId}/${door.cameraId}/${door.closeState}`;
      this.opened = `${trainingBase}/training/${door.edgeId}/${door.cameraId}/${door.openState}`;
      if (door.name) {
        this.form.patchValue({ name: door.name });
      }
    }
  }

  close() {
    this.dialogRef.close();
  }

  add() {
    this.form.markAsTouched();
    if (this.form.invalid) {
      return;
    }
    this.dialogRef.close(this.form.value.name);
  }

  public ngOnDestroy(): void {}

  select(id: string) {
    if (this.data.selector) {
      if (this.selectedDoorIds.includes(id)) {
        this.selectedDoorIds.splice(this.selectedDoorIds.indexOf(id), 1);
      } else {
        this.selectedDoorIds.push(id);
      }
      return;
    }
    this.selectedDoorId = id;
  }

  public filtered(doors: DoorModels.Door[]) {
    return doors.filter((p) => p.name.toLowerCase().includes(this.query.toLowerCase()));
  }

  public exists(id: string) {
    return !this.data.list.map((p) => p.id).includes(id);
  }

  public yes() {
    switch (this.addState) {
      case DoorAddState.CLOSE_STATE:
        this.addState = DoorAddState.OPEN_STATE;
        break;
      case DoorAddState.OPEN_STATE:
        this.addState = DoorAddState.NAME;
        break;
      case DoorAddState.NAME:
        // save
        this.dialogRef.close(this.form.get('name').value);
        break;
    }
  }

  public no() {
    this.addState = DoorAddState.NO_DATA;
  }

  public done() {
    this.dialogRef.close({ delete: true });
  }
}
